export const videoThumbnails: Record<number, string> = {
  1: 'https://cemilkuafor.smarthizmet.com/imgur/sv1.png',
  2: 'https://cemilkuafor.smarthizmet.com/imgur/sv2.png',
  3: 'https://cemilkuafor.smarthizmet.com/imgur/sv3.png',
  4: 'https://cemilkuafor.smarthizmet.com/imgur/sv4.png',
  5: 'https://cemilkuafor.smarthizmet.com/imgur/sv5.png',
  6: 'https://cemilkuafor.smarthizmet.com/imgur/sv6.png',
  7: 'https://cemilkuafor.smarthizmet.com/imgur/sv7.png',
  8: 'https://cemilkuafor.smarthizmet.com/imgur/sv8.png',
  9: 'https://cemilkuafor.smarthizmet.com/imgur/sv9.png',
  10: 'https://cemilkuafor.smarthizmet.com/imgur/sv10.png',
  11: 'https://cemilkuafor.smarthizmet.com/imgur/sv11.png',
  12: 'https://cemilkuafor.smarthizmet.com/imgur/sv12.png',
  13: 'https://cemilkuafor.smarthizmet.com/imgur/sv13.png',
  14: 'https://cemilkuafor.smarthizmet.com/imgur/sv14.png',
  15: 'https://cemilkuafor.smarthizmet.com/imgur/sv15.png',
};

export const videoSources: Record<number, string> = {
  1: 'https://cemilkuafor.smarthizmet.com/sv1.mp4',
  2: 'https://cemilkuafor.smarthizmet.com/sv2.mp4',
  3: 'https://cemilkuafor.smarthizmet.com/sv3.mp4',
  4: 'https://cemilkuafor.smarthizmet.com/sv4.mp4',
  5: 'https://cemilkuafor.smarthizmet.com/sv5.mp4',
  6: 'https://cemilkuafor.smarthizmet.com/sv6.mp4',
  7: 'https://cemilkuafor.smarthizmet.com/sv7.mp4',
  8: 'https://cemilkuafor.smarthizmet.com/sv8.mp4',
  9: 'https://cemilkuafor.smarthizmet.com/sv9.mp4',
  10: 'https://cemilkuafor.smarthizmet.com/sv10.mp4',
  11: 'https://cemilkuafor.smarthizmet.com/sv11.mp4',
  12: 'https://cemilkuafor.smarthizmet.com/sv12.mp4',
  13: 'https://cemilkuafor.smarthizmet.com/sv13.mp4',
  14: 'https://cemilkuafor.smarthizmet.com/sv14.mp4',
  15: 'https://cemilkuafor.smarthizmet.com/sv15.mp4',
};

export const beforeAfterImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=seamless%20micro%20link%20hair%20extension%20result%20invisible%20bonds%20natural%20blend%20luxury%20hair%20design%20warm%20soft%20lighting%20beige%20background%20elegant&width=600&height=800&seq=ba1&orientation=portrait',
  2: 'https://readdy.ai/api/search-image?query=natural%20hair%20color%20blend%20with%20extensions%20perfect%20color%20match%20luxury%20salon%20result%20warm%20beige%20gold%20tones%20premium%20lighting%20elegant&width=600&height=800&seq=ba2&orientation=portrait',
  3: 'https://readdy.ai/api/search-image?query=full%20voluminous%20long%20hair%20after%20micro%20link%20extensions%20healthy%20shiny%20hair%20luxury%20salon%20result%20warm%20lighting%20beige%20background%20beautiful&width=600&height=800&seq=ba3&orientation=portrait',
  4: 'https://readdy.ai/api/search-image?query=long%20healthy%20beautiful%20glossy%20hair%20professional%20hair%20care%20result%20luxury%20salon%20warm%20lighting%20beige%20gold%20tones%20premium%20atmosphere%20elegant%20woman&width=600&height=800&seq=ba4&orientation=portrait',
};

export const serviceImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=micro%20link%20hair%20extension%20professional%20application%20luxury%20salon%20close-up%20soft%20warm%20lighting%20beige%20gold%20tones%20premium%20hair%20design%20elegant%20result&width=800&height=600&seq=s1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=ombre%20hair%20color%20modern%20gradient%20technique%20luxury%20salon%20result%20soft%20warm%20lighting%20beige%20gold%20tones%20premium%20hair%20design%20beautiful&width=800&height=600&seq=s2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=permanent%20blow%20dry%20sleek%20shiny%20smooth%20hair%20result%20luxury%20salon%20professional%20treatment%20warm%20lighting%20beige%20gold%20tones%20premium%20elegant&width=800&height=600&seq=s3&orientation=landscape',
};

export const whyIcons: Array<{ id: number; icon: string }> = [
  { id: 1, icon: 'ri-eye-line' },
  { id: 2, icon: 'ri-palette-line' },
  { id: 3, icon: 'ri-heart-line' },
  { id: 4, icon: 'ri-shield-check-line' },
  { id: 5, icon: 'ri-map-pin-line' },
];